(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefit-cards"] && !Shopify.designMode) return;
  try {
     
var mySwiper = new Swiper('.swiper', {
  slidesPerView: 1,
  spaceBetween: 40,
  pagination: {
    el: '.swiper-pagination',
    clickable :true,
  },
  breakpoints: { 
      500: {  //当屏幕宽度大于等于500
        slidesPerView: 2,
        spaceBetween: 20
      },
      1000: {  //当屏幕宽度大于等于1000
        slidesPerView: 4,
        spaceBetween: 0
      }
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-shippingrule"]) return;
  try {
    
    var Swipercombox = new Swiper ('.swiper-container', {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination-combox',
        clickable:true,    
      },
  })       

  } catch(e) { console.error(e); }
})();
})();
